/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { FinalizedLTI1p1Provider } from './FinalizedLTI1p1Provider';
import { FinalizedLTI1p3Provider } from './FinalizedLTI1p3Provider';
import { NonFinalizedLTI1p1Provider } from './NonFinalizedLTI1p1Provider';
import { NonFinalizedLTI1p3Provider } from './NonFinalizedLTI1p3Provider';
const LTIProviderBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    NonFinalizedLTI1p3Provider,
    NonFinalizedLTI1p1Provider,
    FinalizedLTI1p3Provider,
    FinalizedLTI1p1Provider,
]);
export const LTIProviderBase = LTIProviderBaseParser;
